import React, { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiLogout, apiMe } from "@/lib/api";
import { jalurPublik } from "@/lib/baseUrl";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user: null = still checking, false = not authenticated, object = authenticated
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Public pages are unauthenticated — skip the /me probe there.
    if (jalurPublik(window.location.pathname)) {
      setUser(false);
      return;
    }
    (async () => {
      try {
        const me = await apiMe();
        setUser(me);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const login = async (username, password) => {
    const u = await apiLogin(username, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
